import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ChartsModule } from 'ng2-charts';

import { PagesComponent } from './pages.component';

import { HomeComponent } from './home/home.component';
import { UsersComponent } from './users/users.component';
import { PushNotificationsComponent } from './push-notifications/push-notifications.component';
import { NotificationCalendarComponent } from './notificationcalendar/notificationcalendar.component';

import { PiechartComponent } from '../component/piechart/piechart.component';
import { BarchartComponent } from '../component/barchart/barchart.component';

import { PAGES_ROUTES } from './pages.routes';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { CardMenuComponent } from '../component/card-menu/card-menu.component';
import { FileuploadComponent } from '../component/fileupload/fileupload.component';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../pipes/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { AgmCoreModule } from '@agm/core';
import { GooglemapComponent } from '../component/googlemap/googlemap.component';
import { AlertComponent } from '../component/alert/alert.component';
import { CalendarNotificationComponent } from '../component/calendar-notification/calendar-notification.component';
import { ScheduleComponent } from './schedule/schedule.component';

@NgModule({
    declarations: [
        PagesComponent,
        UsersComponent,
        HomeComponent,
        PushNotificationsComponent,
        NotificationCalendarComponent,
        FileuploadComponent,
        PiechartComponent,
        BarchartComponent,
        CardMenuComponent,
        AccountSettingsComponent,
        GooglemapComponent,
        AlertComponent,
        CalendarNotificationComponent,
        ScheduleComponent,

    ],
    exports: [
        HomeComponent,
        FileuploadComponent,
        GooglemapComponent,
        AlertComponent,
        CalendarNotificationComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        SharedModule,
        PAGES_ROUTES,
        FormsModule,
        ReactiveFormsModule,
        ChartsModule,
        PipesModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBiEMdeG-Uisn06CqlZjC70nIW2oPFK3EE',
            libraries: ['places']
        })
    ]
})

export class PagesModule { }
